import React from 'react'
import {Link, useNavigate} from "react-router-dom";
import Sidebar from "../../../../../components/Sidebar";
import PageHeader from "../../../../../components/PageHeader";
import {toast} from "react-toastify";
import moment from "moment";
import DatePicker, {registerLocale} from "react-datepicker";
import {getSchoolYear} from "../../../../../utils/authority";
import GradeManager from "../../../../../components/Grade";
import ClassRoomController from "../../../../../services/data-declaration/class-room-controller";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import vi from "date-fns/locale/vi";
import PublicSecureAuthorization
    from "../../../../../services/system/secure-authorization/secure-authorization-controller";
import NotiController from "../../../../../services/system/noti/noti-controller";
import FilesApi from "../../../../../services/resource/files-api";
import Dropzone from "react-dropzone";
import Utils from "../../../../../utils/utils";
import ServiceItemController from "../../../../../services/system/service-item/service-item-controller";
registerLocale("vi", vi);
function withRouter(Component) {
    return (props) => <Component {...props} navigate={useNavigate()} />;
}
function uploadAdapter(loader) {
    return {
        upload: () => {
            return new Promise((resolve, reject) => {
                FilesApi.uploadFileCkeditor( loader, res => {
                    if (res.success) {
                        resolve({
                            default: res.data.url
                        });
                    }else {
                        reject(res.error);
                    }
                })
            })
        }
    }
}
function uploadPlugin(editor) {
    editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
        return uploadAdapter(loader);
    };
}
class CreateServiceItemManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: "",
            state: "ACTIVE",
            tax: 0,
            taxNotIncluded: false,
            price: 0,
            unit: "",
            content: "",

            dateEnd: new Date(),
            dateActive: null,
            gradeStr: "",
            groupId: 0,
            yearId: parseInt(getSchoolYear()),
            recipientId: 0,
            listGroupUser: [],
            classRoomId: 0,
            listClassRoom: [],
            files: [],
        };
    }

    componentWillMount() {
    }
    saveContent(newContent) {
        this.setState({
            content: newContent,
        });
    }
    renderStatus() {
        let listStatus = [
            {
                "id": "ACTIVE",
                "name": "Kích hoạt"
            },
            {
                "id": "INACTIVE",
                "name": "Khóa"
            }
        ]
        return listStatus.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    }
    onCreate = () => {
        let price = parseFloat(this.state.price.toString().replaceAll(",", ""))
        if (this.state.name == "" || this.state.name.length < 5){
            toast.error("Tên sản phẩm phải lớn hơn 5 ký tự");
        }else if(this.state.content == ""){
            toast.error("Vui lòng nhập nội dung sản phẩm");
        }else if(this.state.price < 1000){
            toast.error("Vui lòng nhập giá sản phẩm dịc vụ");
        }else {
            let payload = {
                "content": this.state.content,
                "name": this.state.name,
                "price": price,
                "yearId": parseInt(getSchoolYear()),
                "state": this.state.state,

                "tax": parseFloat(this.state.tax),
                "taxNotIncluded": this.state.taxNotIncluded,
                "unit": this.state.unit,
            }
            ServiceItemController.create(payload, res => {
                if (res.success){
                    this.props.navigate('/ad-sas-school/quan-ly-san-pham-dich-vu');
                    toast.success("Tạo sản phẩm thành công!")
                } else {
                    toast.error("Đã xảy ra lỗi! " + res.message)
                }
            })
        }
    }
    render() {
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <Sidebar activeClass="list-service-product" parentClass="service-management"/>
                        <div className="mb-4 col-md-10 tab-content">
                            <div className="card col-12">
                                <div className='pt-3 mb-2'>
                                    <PageHeader routerEnable={true} title="Thêm mới sản phẩm dịch vụ"/>
                                    <div className="mt-4 kt-form kt-form--fit kt-margin-b-20">
                                        <h2 className='text-center mb-4'>THÊM MỚI SẢN PHẨM DỊCH VỤ</h2>
                                        <div className="row">
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Tên dịch vụ/Hàng hóa</label>
                                                <input
                                                    placeholder="Nhập tên dịch vụ/Hàng hóa"
                                                    maxLength={255} type="text"
                                                    className="col-8 form-control shadow-none"
                                                    value={this.state.name}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            name: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mt-2">
                                                <label className="label-item col-4">Trạng thái</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.state}
                                                    onChange={(e) => {
                                                        this.state.state = e.target.value;
                                                        this.setState({
                                                            state: e.target.value
                                                        })
                                                    }}
                                                >
                                                    <option value="">Tất cả</option>
                                                    {this.renderStatus()}
                                                </select>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Giá</label>
                                                <input
                                                    placeholder="Nhập giá sản phẩm"
                                                    maxLength={255}
                                                    type="text"
                                                    className="form-control shadow-none"
                                                    value={Utils.formatMoney(this.state.price)}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            price: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Đơn vị tính</label>
                                                <input
                                                    placeholder="VD: Chiếc, lốc, cái, bộ,..."
                                                    maxLength={255} type="text"
                                                    className="col-8 form-control shadow-none"
                                                    value={this.state.unit}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            unit: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Thuế</label>
                                                <input
                                                    placeholder="Nhập thuế: 10%"
                                                    maxLength={255} type="text"
                                                    className="col-7 form-control shadow-none"
                                                    value={this.state.tax}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            tax: event.target.value
                                                        })
                                                    }}
                                                />
                                                <label className="col-1 label-item pl-0 ml-1"><b>%</b></label>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-1 mt-2">
                                                <div className="checkbox clearfix mr-5">
                                                    <label>
                                                        <input
                                                            type="checkbox"
                                                            onChange={(e) => {
                                                                const value = this.state.taxNotIncluded;
                                                                this.setState({taxNotIncluded: !value});
                                                            }}
                                                            checked={this.state.taxNotIncluded}
                                                        />
                                                        {' '}
                                                        Chưa bao gồm thuế
                                                    </label>
                                                </div>
                                            </div>

                                            <div className="col-xs-12 col-sm-12 col-md-12 p-1 pr-md-3 d-flex">
                                                <label className="label-item col-md-4">Mô tả sản phẩm</label>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-12 p-1 pr-md-3 d-flex">
                                                {/*https://www.techgalery.com/2021/05/how-to-use-react-ckeditor-upload-file.html*/}
                                                <CKEditor
                                                    config={{
                                                        extraPlugins: [uploadPlugin]
                                                    }}
                                                    editor={ ClassicEditor }
                                                    data=""
                                                    onReady={ editor => {
                                                        // You can store the "editor" and use when it is needed.
                                                        // console.log( 'Editor is ready to use!', editor );
                                                    } }
                                                    onChange={ ( event, editor ) => {
                                                        const data = editor.getData();
                                                        this.saveContent(data)
                                                        // console.log( { event, editor, data } );
                                                    } }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="align-right col-12">
                                    <div className="d-flex justify-content-center align-center mt-3 mb-2">
                                        <button
                                            type="button"
                                            className="ml-4 border-1-s background-btn type-button-fix btn btn-primary shadow-none"
                                            disabled={this.state.name == ""}
                                            onClick={()=> {
                                                this.onCreate()
                                            }}
                                        >
                                            Lưu
                                        </button>
                                        <button
                                            type="button"
                                            className="ml-4 border-1-s type-button-fix btn btn-light shadow-none"
                                        >
                                            <Link
                                                style={{color: '#000'}}
                                                to={{
                                                    pathname: "/ad-sas-school/quan-ly-san-pham-dich-vu"
                                                }}
                                            >
                                                Hủy bỏ
                                            </Link>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(CreateServiceItemManagement)
